var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-transition',[(_vm.message)?_c('c-popover',_vm._b({staticClass:"login-warning",attrs:{"element-spacing":"10","position":"top"}},'c-popover',_vm.$attrs,false),[_c('p',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }